import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";


const PartTextField = ({formatPart, setConfigurations, configurations, readOnly, fieldName}) => {

    const { t } = useTranslation();

    const [configuration, setConfiguration] = useState()

    useEffect(() => {
        setConfiguration(configurations.find(c => c.formatPart.id === formatPart.id))
    }, [configurations])

    const handleValueChange = (event) => {

        // Update the specific configuration
        const updatedConfigurations = configurations.map(config => {
            if (config.formatPart.id === formatPart.id) {
                // Return a new object with the updated type field
                return {
                    ...config,
                    [fieldName]: event.target.value
                };
            }
            return config;
        });

        setConfigurations(updatedConfigurations);
    };

    return <>

        {
            readOnly ?
                <>
                    {configuration && configuration[fieldName]}
                </> :

                <div className="react-select__control">  {/* Use React Select control class */}
                    <input
                        className="react-select__input not-visible-input"  // Apply React Select's input class
                        type="text"
                        value={configuration ? configuration[fieldName] : undefined}
                        onChange={handleValueChange}
                        placeholder={readOnly ? "" : t("common.enter")}
                        disabled={!configuration || readOnly}
                        style={{
                            border: 'none',
                            outline: 'none',
                            width: '100%'
                        }}  // Additional styles to match the input look
                    />
                </div>
        }

    </>;
}

export default PartTextField;